import React, { useState, useEffect } from "react";
import AppNavBar from "../../components/Navigation/AppNavBar/AppNavBar";
// import AppDrawer from "../../components/Navigation/AppDrawer/AppDrawer";
import UserMenu from "./../../components/Navigation/AppNavBar/UserMenu/UserMenu";
import { useSelector, useDispatch } from "react-redux";
import { IsMobile } from "./../../utils/utils";
import { waitingAlert } from "../../utils/alerts";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
// import { DRAWER_MINI_WIDTH, DRAWER_WIDTH, HEADER_HEIGHT } from "../../constants/ui";
import { setDrawerOpen } from "../../store/reducers/app";
import { userLogout } from "../../store/actions/user";
import { ContactButton, Footer } from "../../components/LoginPage/LoginPage";
import FormChangePassword from "../../components/ChangePassword/FormChangePassword";

require("moment/locale/en-gb.js");
require("moment/locale/es.js");

const AppLayout = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector((state) => state.user.user);
  const { drawerOpen, changePassword, openDrawerEnabled, darkMode } = useSelector((state) => state.app);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState(null);
  const isMobile = IsMobile();
  const [manualDrawerMini, setManualDrawerMini] = useState(false);

  useEffect(() => {
    document.body.classList.remove("dark-mode");
    document.body.classList.remove("ligh-mode");
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.add("ligh-mode");
    }
  }, [darkMode]);

  const sideDrawerToggleHandler = () => {
    if (openDrawerEnabled) {
      dispatch(setDrawerOpen(!drawerOpen));
    }
  };

  const changeDrawerOpenHandler = (open) => {
    if (!open || openDrawerEnabled) dispatch(setDrawerOpen(open));
  };

  const logoutHandler = () => {
    waitingAlert({ t: t, waitingFunction: userLogoutHandler });
  };
  const userLogoutHandler = () => {
    return userLogout(dispatch);
  };

  const changeUserMenuOpenHandler = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setMenuPosition(e.clientX);
    setUserMenuOpen(!userMenuOpen);
  };

  const clickPageHandler = () => {
    closeUserMenuHandler();
  };
  const clickHeaderHandler = () => {
    closeUserMenuHandler();
  };

  const closeUserMenuHandler = () => {
    setUserMenuOpen(false);
    setMenuPosition(null);
  };

  const clickLayoutHandler = () => {
    if (isMobile && drawerOpen) {
      dispatch(setDrawerOpen(false));
    }
  };

  const changeDrawerMiniHandler = () => {
    if (!isMobile) {
      setManualDrawerMini(!manualDrawerMini);
    }
  };

  return (
    <div className={["d-flex flex-grow-1 h-100"].join(" ")} onClick={clickPageHandler}>
      {/* <AppDrawer
        user={user}
        onChangeDrawerOpen={changeDrawerOpenHandler}
        drawerOpen={drawerOpen}
        drawerToggleClicked={sideDrawerToggleHandler}
        userMenuHandler={changeUserMenuOpenHandler}
        manualDrawerMini={manualDrawerMini}
        onChangeDrawerMini={changeDrawerMiniHandler}
      /> */}
      <Box
        // sx={
        //   drawerOpen && manualDrawerMini
        //     ? {
        //         marginLeft: `${DRAWER_MINI_WIDTH}px`,
        //       }
        //     : drawerOpen && drawerMini && !isMobile
        //     ? {
        //         marginLeft: `${DRAWER_MINI_WIDTH}px`,
        //       }
        //     : drawerOpen && !isMobile
        //     ? {
        //         marginLeft: `${DRAWER_WIDTH}px`,
        //       }
        //     : {}
        // }
        className={["d-flex flex-grow-1 flex-column"].join(" ")}
        onClick={clickLayoutHandler}
      >
        <AppNavBar
          drawerToggleClicked={sideDrawerToggleHandler}
          onBarClick={clickHeaderHandler}
          userMenuHandler={changeUserMenuOpenHandler}
          user={user}
        />
        {user && (
          <UserMenu
            user={user}
            onLogout={logoutHandler}
            onChangeOpen={changeUserMenuOpenHandler}
            open={userMenuOpen}
            menuPosition={menuPosition}
            onClose={closeUserMenuHandler}
          />
        )}
        <Box
          // sx={{ height: "100vh", overflowX: "hidden !important", paddingTop: `${HEADER_HEIGHT}px` }}
          className={["d-flex flex-column flex-grow-1 overflow-hidden"].join(" ")}
          sx={{ paddingBottom: "40px" }}
        >
          {props.children}
        </Box>

        {changePassword && <FormChangePassword />}
        {/* <ContactButton /> */}
        <Footer isMobile={isMobile} fixed />
      </Box>
    </div>
  );
};

export default AppLayout;
